export const AUDIT_LOG_TYPES = ['message', 'audit'];

export const AUDIT_LOG_DEFAULT_ACTIONS = ['modifications', 'non-modifications'];

export const AUDIT_LOG_ACTIONS_LABEL: { [key: string]: string } = {
  create: 'Created',
  update: 'Updated',
  delete: 'Deleted',
  'campaign-report': 'Campaign report',
  view: 'View',
  allocate: 'Allocate',
  like: 'Like',
  unallocate: 'Unallocate',
  unlike: 'Unlike',
  login: 'Login',
  logout: 'Logout',
  modifications: 'Modifications',
  'non-modifications': 'Non-modifications',
};
